import { AgentAvatarVariant } from './AgentAvatar.types.ts';

export const VARIANT_MAP: Record<
  AgentAvatarVariant,
  { fontSize: string; width: string; height: string; iconSize: number; margin?: string }
> = {
  small: {
    fontSize: '12px',
    width: '24px',
    height: '24px',
    iconSize: 14,
    margin: '0',
  },
  medium: {
    fontSize: '12px',
    width: '28px',
    height: '28px',
    iconSize: 16,
    margin: '0',
  },
  normal: {
    fontSize: '14px',
    width: '32px',
    height: '32px',
    iconSize: 18,
    margin: '0',
  },
  large: {
    fontSize: '22px',
    width: '60px',
    height: '60px',
    iconSize: 32,
    margin: '0',
  },
  'card-active': {
    fontSize: '30px',
    width: '70px',
    height: '70px',
    iconSize: 38,
    margin: '0 0 0 32px',
  },
  'card-normal': {
    fontSize: '14px',
    width: '50px',
    height: '50px',
    iconSize: 28,
    margin: '0',
  },
};
